import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { Authentication } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTSURVEYRESP,
  DELETE_LABREQUESTSURVEYRESP,
  GET_LABREQUESTSURVEYRESPS,
  UPDATE_LABREQUESTSURVEYRESP
} from "./actionTypes";
import {
  addLabRequestSurveyRespFail,
  addLabRequestSurveyRespSuccess,
  deleteLabRequestSurveyRespFail,
  deleteLabRequestSurveyRespSuccess,
  getLabRequestSurveyRespsFail,
  getLabRequestSurveyRespsSuccess,
  setState,
  updateLabRequestSurveyRespFail,
  updateLabRequestSurveyRespSuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestSurveyResps( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, Authentication, params.toString());
    yield put(setState(false))
    yield put(getLabRequestSurveyRespsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestSurveyRespsFail(error));
  }
}

function* updateLabRequestSurveyResp ({payload: labRequestSurveyRespObj }) {
  try {
    const response = yield call(getTable,`${Authentication}/${labRequestSurveyRespObj.id}`);
    yield put(updateLabRequestSurveyRespSuccess(response));
  } catch (error) {
    yield put(updateLabRequestSurveyRespFail(error));
  }
}

function* deleteLabRequestSurveyResp ({payload: labRequestSurveyRespObj}) {
  try {
    yield put(deleteLabRequestSurveyRespSuccess(labRequestSurveyRespObj.id));
  } catch (error) {
    yield put(deleteLabRequestSurveyRespFail(error));
  }
}

function* postingLabRequestSurveyResp ({ payload: labRequestSurveyResp}) {
  try {
    const response = yield call(postApiCall, Authentication ,labRequestSurveyResp);
    const response1 = yield call(getTable,`${Authentication}/${response.id}`);
    yield put(addLabRequestSurveyRespSuccess(response1));
  } catch (error) {
    yield put(addLabRequestSurveyRespFail(error));
  }
}

function* labRequestSurveyRespsSaga() {
  yield takeEvery(GET_LABREQUESTSURVEYRESPS, fetchLabRequestSurveyResps);
  yield takeEvery(ADD_NEW_LABREQUESTSURVEYRESP, postingLabRequestSurveyResp);
  yield takeEvery(UPDATE_LABREQUESTSURVEYRESP, updateLabRequestSurveyResp);
  yield takeEvery(DELETE_LABREQUESTSURVEYRESP, deleteLabRequestSurveyResp);
}

export default labRequestSurveyRespsSaga;
